module.exports = "<div id=\"map-canvas\" ng-style=\"{width:$ctrl.width, height: $ctrl.height}\"></div>\n"